var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "post-item" }, [
    _c("div", { staticClass: "post-item__wrapper" }, [
      _c("a", { staticClass: "post-item__link", attrs: { href: _vm.link } }),
      _vm._v(" "),
      _c("div", { staticClass: "post-item__image" }, [
        _vm.image ? _c("img", { attrs: { src: _vm.image } }) : _vm._e(),
        _vm._v(" "),
        _vm.primaryTopic
          ? _c("span", { staticClass: "post-item__topic" }, [
              _vm._v(_vm._s(_vm.primaryTopic))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "post-item__content" }, [
        _c("h4", { staticClass: "post-item__title" }, [
          _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn--grey btn--smallest",
            attrs: { href: _vm.link }
          },
          [_vm._v("Find Out More")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }